module.exports = __webpack_public_path__ + "media/site_templates/www.cheapplumber.net.au/images/about_us-5212380641a07b466d4a27e68dbdb62f.jpg";